module.exports = __webpack_public_path__ + "img/upload_black_icon.e12b46e3.png";